import { InvalidReason } from "utils/invalidRoute";

type InvalidPageContent = {
  title: string;
  description: string;
};

export const INVALID_PAGE_CONTENT: Record<InvalidReason, InvalidPageContent> = {
  link: {
    title: "This link is invalid or has expired",
    description:
      "The link you opened may be incomplete, expired, already used, or meant for a different account. Please use the most recent link sent to you, or contact the business for a new one.",
  },
  "not-found": {
    title: "Page not found",
    description:
      "The page you're looking for doesn't exist or is no longer available. Please check the address and try again.",
  },
  unavailable: {
    title: "This service is currently unavailable",
    description:
      "Online payments aren't available here right now. Please contact the business directly for help with your account.",
  },
};
